import { getBranchFromDb, getCompanyFromDb, getTaxSeriesFromDb } from "./CommonService";

const { getCookie } = require("./CommonFunctions");
const { LOGIN_COOKIE_NAME_SPLITBY, APP_TYPE_COOKIE_NAME, LOGIN_COOKIE_NAME, MMB_LIVE, MMB, COMMON_LOADRECIEVERDETAIL, MASTER_CLIENTRATEFORCOURIER, API_PATH } = require("./CommonVariable");



// MMB
export async function calculateBookingFreightAmtForCourier(masterData, clientCode, networkCode, serviceGroupCode, destinationCode, doIn, billWt, docType){
        let wt=0.100;
        let amt = 0;
        let {doZoning,inZoning} = getZoningDetail(masterData);
        let hashMap_ClientRatesCourier = await getClientRatesForCourier(clientCode);
        console.log("zone in and do", doZoning,inZoning);
        let SE = "SE";
        let ZO = "ZO";
        let ZONE_CODE = "";
        let SERVICE_GROUP_CODE = "";
        let WEIGHT_SLAB_TYPE = "";
        let WEIGHT_SLAB_AMOUNT = 0;
        // console.log(destinationCode);

        let rateList = getClientRateCourier(hashMap_ClientRatesCourier,clientCode,networkCode,serviceGroupCode,SE,destinationCode)
        console.log("getClientRateCourier",rateList);
        console.log("hashMap_client",hashMap_ClientRatesCourier);
        if(!rateList){
            let lstZone = [];
            if ('DO'==doIn) {
                lstZone = doZoning.get(destinationCode);
            } else if ("IN"==doIn) {
                lstZone = inZoning.get(destinationCode);
            }
            if (lstZone !== null && lstZone.length>0) {
                for (let zone of lstZone) {
                    if (checkClientRateCourier(hashMap_ClientRatesCourier, clientCode, networkCode, serviceGroupCode, ZO, zone)) {
                        // console.log("in tis if of checkClientRateCourier to get again rateList")
                        ZONE_CODE = zone;
                        SERVICE_GROUP_CODE = serviceGroupCode;
                        rateList = getClientRateCourier(hashMap_ClientRatesCourier, clientCode, networkCode, serviceGroupCode, ZO, zone);
                        break;
                    }
                }
            }
        }
        // console.log(rateList);

        if(!rateList){
            return {
            amt,WEIGHT_SLAB_AMOUNT,WEIGHT_SLAB_TYPE,ZONE_CODE
        };
        }

        let rateApplied = true;
        let B = "B", A = "A", K = "K";
        let doxRate = 0, nonDoxRate = 0;
        let highestBasicSlabWt = 0, highestBasicSlabDoxRate = 0, highestBasicSlabNonDoxRate = 0;

        for (let bean of rateList) {
            if (bean.rate_type === B) {
                if (billWt >= bean.weight_from && billWt <= bean.weight_to) {
                    rateApplied = false;
                    doxRate = bean.dox;
                    nonDoxRate = bean.nondox;
                    WEIGHT_SLAB_TYPE = bean.rate_type;
                    WEIGHT_SLAB_AMOUNT = bean.dox;
                    break;
                }
                highestBasicSlabWt = bean.weight_to;
                highestBasicSlabDoxRate = bean.dox;
                highestBasicSlabNonDoxRate = bean.nondox;

            }
        }


        if (rateApplied) {
            for (let bean of rateList) {
                if (bean.rate_type === A && billWt <= bean.weight_from) {
                    rateApplied = false;
                    let z = (billWt - highestBasicSlabWt) / bean.weight_to;
                    let slot = z;
                    // console.log((billWt - highestBasicSlabWt) % bean.weight_to);
                    if ((billWt - highestBasicSlabWt) % bean.weight_to > 0) {
                        slot++;
                    }
                    doxRate = highestBasicSlabDoxRate + (slot * bean.dox);
                    nonDoxRate = highestBasicSlabNonDoxRate + (slot * bean.nondox);
                    WEIGHT_SLAB_TYPE = bean.rate_type;
                    WEIGHT_SLAB_AMOUNT = bean.dox;
                    break;
                }
            }
        }
        if (rateApplied) {
            for (let bean of rateList) {
                if (bean.rate_type === K) {
                    if (billWt >= bean.weight_from && billWt <= bean.weight_to) {
                        doxRate = Math.ceil(billWt) * bean.dox;
                        nonDoxRate = Math.ceil(billWt) * bean.nondox;
                        WEIGHT_SLAB_TYPE = bean.rate_type;
                        WEIGHT_SLAB_AMOUNT = bean.dox;
                        break;
                    }
                }
            }
        }

        
        if (docType=="D") {
            amt = doxRate;
        } else if (docType=="N") {
            amt = nonDoxRate;
        }
        return {
            amt,WEIGHT_SLAB_AMOUNT,WEIGHT_SLAB_TYPE,ZONE_CODE
        };
}

export function checkClientRateCourier(hashMap_ClientRatesCourier, clientCode, networkCode, serviceGroupCode, type, zone) {
    let DEL = 'DEL';
        let result = hashMap_ClientRatesCourier.has(clientCode.trim() + networkCode.trim() + serviceGroupCode.trim() + DEL + type.trim() + zone.trim());
        if (result === false) {
            result = hashMap_ClientRatesCourier.has(clientCode.trim() + networkCode.trim() + serviceGroupCode.trim() + type.trim() + zone.trim());
        }
        // console.log("with del" , clientCode.trim() + networkCode.trim() + serviceGroupCode.trim() + DEL + type.trim() + zone.trim());
        // console.log('without del',clientCode.trim() + networkCode.trim() + serviceGroupCode.trim() + type.trim() + zone.trim());
        return result;
    }

export function getClientRateCourier(hashMap_ClientRatesCourier,clientCode, networkCode, serviceGroupCode, type, zone) {
    let DEL = 'DEL';
console.log('getClientRateCourier',clientCode,networkCode,serviceGroupCode,DEL,type,zone);
    let rateList = hashMap_ClientRatesCourier.get(clientCode.trim() + networkCode.trim() + serviceGroupCode.trim() + DEL + type.trim() + zone.trim());
    if (rateList === null) {
        rateList = hashMap_ClientRatesCourier.get(clientCode.trim() + networkCode.trim() + serviceGroupCode.trim() + type.trim() + zone.trim());
    }
    return rateList;
}

export function getZoningDetail(masterData) {
    const hashMap_DoZoning = new Map();
    const hashMap_InZoning = new Map();

    for (const pincode of masterData.LIST_PINCODE) {
        if(pincode.zoning_type==='')continue;
        const zoningType = pincode.zoning_type.toUpperCase();

        if (zoningType === "DO") {
            if (hashMap_DoZoning.has(pincode.city_code)) {
                hashMap_DoZoning.get(pincode.city_code).push(pincode.zone_code);
            } else {
                hashMap_DoZoning.set(pincode.city_code, [pincode.zone_code]);
            }
        } 
        else if (zoningType === "IN") {
            if (hashMap_InZoning.has(pincode.state_code)) {
                hashMap_InZoning.get(pincode.state_code).push(pincode.zone_code);
            } else {
                hashMap_InZoning.set(pincode.state_code, [pincode.zone_code]);
            }
        }
    }

    return {
        doZoning: hashMap_DoZoning,
        inZoning: hashMap_InZoning
    };
}

export async function getClientRatesForCourier(clientCode){
    const cookie = getCookie(LOGIN_COOKIE_NAME);
    const userType = getCookie(APP_TYPE_COOKIE_NAME);
    const c = cookie.split(LOGIN_COOKIE_NAME_SPLITBY);
    try {
            let column = '';
            let tableName = '';
            let condition = '';
            let Data = "clientrateforcourier";
            if(userType===MMB_LIVE){
                return;
            }else if(userType===MMB) {
                column = "ctm.client_cd as client_cd, ctm.network_cd as network_cd, ctm.service_cd as service_cd, ctm.series as series, ctm.origin as origin, ctm.type as type,"
                         +"ctm.zone_sec_cd as zone_sec_cd, ctm.special as special, ctdm.clientTariff_cd as clientTariff_cd, ctdm.rate_type as rate_type,"
                         +"ctdm.weight_from as weight_from, ctdm.weight_to as weight_to, ctdm.dox as dox, ctdm.nondox as nondox";
                tableName = "client_tariff_master as ctm left join client_tariff_detail_master ctdm on ctm.clientTariff_cd = ctdm.clientTariff_cd "
                condition =" where ctm.client_cd = '"+clientCode+"'"
                            +"order by ctdm.clientTariff_cd,"
                            +"case "
                            +"when ctdm.rate_type = 'B' then 0 "
                            +"when ctdm.rate_type = 'A' then 1 "
                            +"when ctdm.rate_type = 'K' then 2 "
                            +"end, ctdm.rate_type,"
                            +"ctdm.weight_from";
            }

            const query = { "userKey": c[0],"column": column,"beanname":Data,"value":condition};
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: new URLSearchParams({
                    query: JSON.stringify(query),
                    key:"checkService",
                    tableName:tableName
                })
            };
            const res = await fetch(API_PATH + MASTER_CLIENTRATEFORCOURIER + "getdata", requestOptions);
            const data = await res.json();
            const response = data?.[0]?.clientrateforcourier || [];
            if (response.length > 0) {
                console.log("clientrateforcourier response:", response);

                let clientTariffCode = '';
                let arrList = [];
                const hashMap_ClientRatesCourier = new Map();

                for (const bean of response) {

                    if (!bean.clientTariff_cd || bean.clientTariff_cd.trim().toLowerCase() === "null") {
                        continue;
                    }

                    const currentCode = bean.clientTariff_cd.trim();

                    // Initialize first value
                    if (clientTariffCode === '') {
                        clientTariffCode = currentCode;
                    }

                    // If tariff changes → save previous list
                    if (clientTariffCode !== '' && clientTariffCode !== currentCode) {
                        hashMap_ClientRatesCourier.set(clientTariffCode, arrList);
                        arrList = [];
                        clientTariffCode = currentCode;
                    }

                    // Add bean to current group
                    if (clientTariffCode === currentCode) {
                        arrList.push({
                            client_cd: bean.client_cd?.trim(),
                            network_cd: bean.network_cd?.trim(),
                            service_cd: bean.service_cd?.trim(),
                            series: bean.series?.trim(),
                            origin: bean.origin?.trim(),
                            type: bean.type?.trim(),
                            zone_sec_cd: bean.zone_sec_cd?.trim(),
                            special: bean.special?.trim(),
                            clientTariff_cd: currentCode,
                            rate_type: bean.rate_type?.trim(),
                            weight_from: Number(bean.weight_from),
                            weight_to: Number(bean.weight_to),
                            dox: Number(bean.dox),
                            nondox: Number(bean.nondox)
                        });
                    }
                }
                if (arrList.length > 0) {
                    hashMap_ClientRatesCourier.set(clientTariffCode, arrList);
                }

                return hashMap_ClientRatesCourier;

            } else {
                return new Map();
            }
    } catch (err) {
        console.log(err.message);
        return new Map();
    }
}

export async function getDocketCharge(masterData,clientCode,service,network,freigthAmt,insValue,fodVal,codVal) {
    let docketCharge = 0;
    let fuelAmt = 0;
    let hashmap_clientVas = new Map();
    for(let clientVas of masterData.LIST_CLIENTVAS){
        if(clientVas.client_code === clientCode){
            if (clientVas.service_group_code === service && clientVas.network_code === network) {
                docketCharge = clientVas ? clientVas.docket_amount : 0;
                let fuelRate = clientVas.fuel_rate;
                if(clientVas.fuel_on_vas === 'YES'){
                fuelAmt = ((freigthAmt + docketCharge + insValue + fodVal + codVal) * fuelRate )/100
                }else{
                    fuelAmt = (freigthAmt *fuelRate)/100;
                }

                let codFixed = clientVas.cod_fixed;

                
                return  {
                            'docketCharge':docketCharge,
                            'fuelAmt':fuelAmt,
                            'fuelRate':fuelRate
                        };
            }

            if (clientVas.service_group_code === service && clientVas.network_code === 'ALL') {
                hashmap_clientVas.set(0, clientVas);
            } 
            else if (clientVas.network_code === network && clientVas.service_group_code === 'ALL') {
                hashmap_clientVas.set(1, clientVas);
            } 
            else if (clientVas.network_code === 'ALL' && clientVas.service_group_code === 'ALL') {
                hashmap_clientVas.set(2, clientVas);
            }
        }
    }
    // console.log(hashmap_clientVas);

    let bean = hashmap_clientVas.get(0) || hashmap_clientVas.get(1) || hashmap_clientVas.get(2);
    docketCharge = Number(bean?.docket_amount ?? 0);
    let fuelRate = Number(bean?.fuel_rate ?? 0);
    let fuelOnVas = bean?.fuel_on_vas ?? 'NO';
    freigthAmt = Number(freigthAmt) || 0;
    insValue = Number(insValue) || 0;
    fodVal = Number(fodVal) || 0;
    codVal = Number(codVal) || 0;

    if(fuelOnVas === 'YES'){
    fuelAmt = ((freigthAmt + docketCharge + insValue + fodVal + codVal) * fuelRate )/100
    }else{
        fuelAmt = (freigthAmt *fuelRate)/100;
    }
    console.log(fuelAmt,"fuelAmt");
    return  {
        'docketCharge':docketCharge,
        'fuelAmt':fuelAmt,
        'fuelRate':fuelRate
    }
}

export async function calculateTax(masterData,clientCode,freigth,docketChrg,fuelAmt,insval) {
    let tax = 0;
    let beanCl;
    for(let client of masterData.LIST_CLIENT){
        if(client.client_code === clientCode){
            beanCl = client;
            break;
        }
    }

    if(!beanCl)return;

    let taxObject = await getTaxSeriesFromDb();
    if(taxObject.length===0)return alert("Tax data detail not found");

    let cgst = 0;
    let sgst = 0;
    let igst = 0;

    let cgstTax = taxObject[0].tax_rate;
    let sgstTax = taxObject[0].edu_cess_rate;
    let igstTax = taxObject[0].higher_cess_rate;

    console.log("beanCl.client_type",beanCl.client_type);
    const company = await getCompanyFromDb(beanCl.client_type);

    freigth = Number(freigth);
    docketChrg = Number(docketChrg);
    insval = Number(insval);
    fuelAmt = Number(fuelAmt);

    console.log('freigth',freigth);
    console.log('docketChrg',docketChrg);
    console.log('insval',insval);
    console.log('fuelAmt',fuelAmt);

    let taxableAmount = freigth + docketChrg + insval + fuelAmt;

    let clientStateCode = '';
    let compStateCode = company[0].stateCode;
    for(let pin of masterData.LIST_PINCODE){
        if(pin.pin_code === beanCl.zip_code){
            clientStateCode = pin.state_code;
            break;
        }
    }

    console.log('clientState',clientStateCode);
    console.log('comp',company[0].stateCode);
    if(clientStateCode === compStateCode){
        cgst = (taxableAmount * cgstTax)/100;
        sgst = (taxableAmount * sgstTax)/100;
    }else{
        igst = (taxableAmount * igstTax)/100;
    }

    let totalTax = cgst + sgst + igst;
    let finalAmount = taxableAmount + totalTax;

    return {
        taxableAmount,
        cgst,
        sgst,
        igst,
        totalTax,
        finalAmount,
        taxObject
    };
}

// export function getFuelRateAmt(masterData,clientCode,network_code,service,freigthAmt,docketcharge,insValue,fodVal,codVal){
//     for(let clientVas of masterData.LIST_CLIENTVAS){
//         if(clientVas.client_code === clientCode){
//             if (clientVas.service_group_code === service && clientVas.network_code === network) {
//                 return clientVas.docket_amount;
//             }

//             if (clientVas.service_group_code === service && clientVas.network_code === 'ALL') {
//                 hashmap_clientVas.set(0, clientVas);
//             } 
//             else if (clientVas.network_code === network && clientVas.service_group_code === 'ALL') {
//                 hashmap_clientVas.set(1, clientVas);
//             } 
//             else if (clientVas.network_code === 'ALL' && clientVas.service_group_code === 'ALL') {
//                 hashmap_clientVas.set(2, clientVas);
//             }
//         }
//     }
//     console.log(hashmap_clientVas);
//     let fuelAmt = 0;
//     let bean = hashmap_clientVas.get(0) || hashmap_clientVas.get(1) || hashmap_clientVas.get(2);
//     let fuelRate = bean.fuel_rate;
//     if(bean.fuel_on_vas === 'YES'){
//         fuelAmt = ((freigthAmt + docketcharge + insValue + fodVal + codVal) * fuelRate )/100
//     }else{
//         fuelAmt = (freigthAmt *fuelRate)/100;
//     }

//     return fuelAmt;
// }